{
  "createUser": {
    "title": "Neuen Benutzer erstellen"
  },
  "editUser": {
    "title": "Benutzer bearbeiten"
  },
  "selectUserProfileEdit": {
    "title": "Profil des Benutzers auswählen"
  },
  "userGroups": {
    "title": "Gruppen des Benutzers auswählen"
  }
}
